/**
 * Registers banner choices with Shopify Customer Privacy API where available.
 * @see https://shopify.dev/docs/api/customer-privacy
 */
(function () {
  const root = document.getElementById('privacy-consent-banner');
  if (!root) return;

  const visibility = root.dataset.visibility || 'shopify_regions';
  const designMode = root.dataset.designMode === 'true';

  function consentIsComplete(cp) {
    if (!cp || typeof cp.currentVisitorConsent !== 'function') return false;
    const c = cp.currentVisitorConsent();
    return c.analytics !== '' && c.marketing !== '' && c.preferences !== '';
  }

  function withCustomerPrivacy(done) {
    if (!window.Shopify || typeof window.Shopify.loadFeatures !== 'function') {
      done(new Error('Shopify.loadFeatures unavailable'), null);
      return;
    }
    window.Shopify.loadFeatures(
      [{ name: 'consent-tracking-api', version: '0.1' }],
      (err) => {
        if (err || !window.Shopify.customerPrivacy) {
          done(err || new Error('customerPrivacy missing'), null);
        } else {
          done(null, window.Shopify.customerPrivacy);
        }
      }
    );
  }

  function hide() {
    root.hidden = true;
  }

  function show() {
    root.hidden = false;
  }

  function applyChoice(acceptAll) {
    const payload = acceptAll
      ? { analytics: true, marketing: true, preferences: true }
      : { analytics: false, marketing: false, preferences: true };

    const finish = () => hide();

    withCustomerPrivacy((_err, cp) => {
      if (cp && typeof cp.setTrackingConsent === 'function') {
        cp.setTrackingConsent(payload, finish);
      } else {
        finish();
      }
    });
  }

  root.querySelector('[data-privacy-consent-action="accept"]')?.addEventListener('click', () => applyChoice(true));
  root.querySelector('[data-privacy-consent-action="essential"]')?.addEventListener('click', () => applyChoice(false));

  if (designMode) {
    show();
    return;
  }

  withCustomerPrivacy((err, cp) => {
    if (err || !cp) {
      if (visibility === 'all_visitors') show();
      else hide();
      return;
    }

    const incomplete = !consentIsComplete(cp);
    const regionWants =
      visibility === 'all_visitors' || (typeof cp.shouldShowBanner === 'function' && cp.shouldShowBanner());

    if (incomplete && regionWants) show();
    else hide();
  });
})();
